import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { APP_VERSION } from '../shared/constants';
import ContactUsModal from './ContactUsModal';

/** Custom event name so other components (e.g. Pricing Pro+ "Contact us") can open this modal */
export const OPEN_CONTACT_US_MODAL_EVENT = 'openContactUsModal';

export default function VersionFooter() {
  const { t } = useTranslation();
  const [showContactModal, setShowContactModal] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handler = () => setShowContactModal(true);
    window.addEventListener(OPEN_CONTACT_US_MODAL_EVENT, handler);
    return () => window.removeEventListener(OPEN_CONTACT_US_MODAL_EVENT, handler);
  }, []);

  return (
    <>
      <div className="bg-dark text-white py-2 mt-4 w-100">
        <div className="container-fluid">
          <div className="text-center">
            <small className="text-white">
              &copy; {new Date().getFullYear()}{' '}
              <a 
                href="/" 
                onClick={(e) => { e.preventDefault(); navigate('/'); }}
                className="text-white text-decoration-none"
                style={{ cursor: 'pointer' }}
              >
                trip147
              </a>
              . {t('footer.allRightsReserved')} |{' '}
              <span 
                onClick={() => setShowContactModal(true)} 
                className="text-white text-decoration-none"
                style={{ cursor: 'pointer' }}
                role="button"
              >
                {t('footer.contactUs')}
              </span>
              {' '}|{' '}
              <a href="/privacy" className="text-white text-decoration-none">{t('footer.privacyPolicy')}</a>
              {' '}|{' '}
              <a href="/terms" className="text-white text-decoration-none">{t('footer.termsOfService')}</a>
              {' '}| {t('footer.version')} {APP_VERSION}
            </small>
          </div>
        </div>
      </div>

      <ContactUsModal 
        show={showContactModal} 
        onHide={() => setShowContactModal(false)} 
      />
    </>
  );
}

